<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        .profile-page__main
          .profile-page__header
            .profile-page__title
              h1.title {{ profileData.title }}
            .profile-page__description {{ profileData.description }}
          .profile-page__body
            form(
              autocomplete="off"
              v-if="userProfileData"
            )
              .profile-page-form
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Общая информация родителя (законного представителя ребенка)

                  .profile-section__body
                    form-parent-info(
                      :last-name="userProfileData.last_name"
                      :first-name="userProfileData.first_name"
                      :fathers-name="userProfileData.fathers_name"
                      :gender="userProfileData.gender"
                      :date-of-birth="userProfileData.date_of_birth"
                      :place-of-birth="userProfileData.place_of_birth"
                      :require-errors="requireErrors"
                      :keymonitor="keymonitor"
                      @onChangeValue="changeValue"
                    )
                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Контакты

                  .profile-section__body
                    form-contacts(
                      :additional-email="userProfileData.additional_email"
                      :phone="userProfileData.phone"
                      :work-phone="userProfileData.work_phone"
                      :require-errors="requireErrors"
                      :unnecessary-errors="unnecessaryErrors"
                      :keymonitor="keymonitor"
                      @onChangeValue="changeValue"
                    )

                section.profile-page-form__section.profile-section
                  .profile-section__title
                    h2.profile-section-title Документы

                  .profile-section__body
                    form-docs(
                      :snils="userProfileData.snils"
                      :inn="userProfileData.inn"
                      :passport="userProfileData.passport"
                      :passport-issue-by="userProfileData.passport_issue_by"
                      :passport-issue-date="userProfileData.passport_issue_date"
                      :passport-attachments="userProfileData.passport_attachments"
                      :another-documents="userProfileData.another_documents"
                      :require-errors="requireErrors"
                      :keymonitor="keymonitor"
                      @onChangeValue="changeValue"
                    )
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Адрес регистрации

              .profile-section__body(
              v-if="userProfileData"
              )
                form-address(
                :address="userProfileData.registration_address"
                :field="'registration_address'"
                :require-errors="requireErrors"
                :keymonitor="keymonitor"
                @on-change-value="changeAddress"
                )
            section.profile-page-form__section.profile-section
              .profile-section__title
                h2.profile-section-title Адрес проживания

              .profile-section__body(
                v-if="userProfileData"
              )
                form-address(
                :address="userProfileData.actual_address"
                :field="'actual_address'"
                :require-errors="requireErrors"
                :keymonitor="keymonitor"
                @on-change-value="changeAddress"
                )

            section.profile-page-form__section.profile-section
              .profile-section__body
                .form
                  .form__elem.form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_long(
                          @click="onSaveProfile()"
                        )
                          .button__text Сохранить
                      .form-elem__error(v-show="showErrorInfo") Не все поля заполнены

    .profile-page__footer.page__footer
      main-footer
</template>
<script>
import {mapState, mapActions} from "vuex";

import MainFooter from "@/components/footer/Footer";
import SideNav from "@/components/sideNav/SideNav";
import FormParentInfo from "../components/forms/FormParentInfo";
import FormContacts from "../components/forms/FormContacts";
import FormDocs from "../components/forms/FormDocs";
import FormAddress from "../components/forms/FormAddress";

export default {
  name: "Profile",
  components: {
    FormAddress,
    FormDocs,
    FormContacts,
    FormParentInfo,
    SideNav,
    MainFooter
  },
  props: ["sideNavData"],
  data() {
    return {
      userProfileData: {},
      profileData: {
        title: "Личный кабинет",
        description:
          "Здесь вы можете изменить данные своего профиля, внести информацию о детях, а также загрузить все необходимые документы для подачи заявки и следить за статусом активных заявок"
      },
      requireErrors: {
        "registration_address.region": false,
        "registration_address.area": false,
        "registration_address.city": false,
        "registration_address.street": false,
        "registration_address.house": false,
        "registration_address.postal_code": false,

        "actual_address.area": false,
        "actual_address.city": false,
        "actual_address.house": false,
        "actual_address.postal_code": false,
        "actual_address.region": false,
        "actual_address.street": false,
        date_of_birth: false,
        fathers_name: false,
        first_name: false,
        gender: false,
        inn: false,
        last_name: false,
        passport: false,
        passport_issue_by: false,
        passport_issue_date: false,
        phone: false,
        place_of_birth: false,
        snils: false
      },
      unnecessaryErrors: {
        additional_email: false,
        work_phone: false
      },
      attachmentErrors: {
        another_documents: false,
        passport_attachments: false
      },
      showErrorInfo: false
    };
  },
  computed: {
    ...mapState(["userData"])
  },
  methods: {
    ...mapActions(["updateUserProfile", "getUser"]),
    keymonitor() {
      const errors = Object.keys(this.requireErrors);
      const nesErrors = Object.keys(this.unnecessaryErrors);
      errors.map(error => {
        this.requireErrors[error] = false;
      });
      nesErrors.map(error => {
        this.unnecessaryErrors[error] = false;
      });
      this.showErrorInfo = false;
    },
    checkRequeres() {
      const requires = [];
      const errors = Object.keys(this.requireErrors);

      errors.map(error => {
        const splitError = error.split(".");
        const isNested = splitError.length > 1;
        if (isNested) {
          if (
            !this.userProfileData[splitError[0]][splitError[1]] ||
            this.userProfileData[splitError[0]][splitError[1]].length === 0
          ) {
            requires.push(error);
          }
        } else {
          if (
            this.userProfileData[error] === null ||
            this.userProfileData[error].length === 0
          ) {
            requires.push(error);
          }
        }
      });

      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.userProfileData.additional_email) {
        if (!reg.test(this.userProfileData.additional_email)) {
          this.unnecessaryErrors.additional_email = true;
          requires.push("additional_email");
        }
      }

      requires.map(requre => {
        this.requireErrors[requre] = true;
      });
      if (requires.length > 0) {
        this.showErrorInfo = true;
      }
      return requires.length !== 0;
    },
    onSaveProfile() {
      const userProfileData = JSON.parse(JSON.stringify(this.userProfileData));
      if (this.checkRequeres()) {
        return;
      }
      userProfileData.passport_attachments = userProfileData.passport_attachments.map(
        el => el.id
      );
      userProfileData.another_documents = userProfileData.another_documents.map(
        el => el.id
      );
      this.updateUserProfile(userProfileData).then(response => {
        if (response.status === 200) {
          this.$root.$emit("onShowNotificationModal", {
            text: "Личный кабинет обновился!"
          });
        }
      });
    },
    changeValue(data) {
      const type = data[1];
      const value = data[0];
      this.userProfileData[type] = value;
    },
    changeAddress(field, item, val) {
      this.userProfileData[field][item] = val;
    },
    onBuildUserData(data) {
      this.userProfileData = JSON.parse(JSON.stringify(data));
    }
  },
  mounted() {
    this.onBuildUserData(this.userData);
  },
  watch: {
    userData(newVal) {
      this.onBuildUserData(newVal);
    }
  }
};
</script>
